// @flow
export const INVOICES_FETCH = 'INVOICES_FETCH'
export const INVOICES_LIMIT_REACHED = 'INVOICES_LIMIT_REACHED'
export const INVOICES_SUCCESS = 'INVOICES_SUCCESS'
export const INVOICES_FAIL = 'INVOICES_FAIL'
